import React from 'react';
import IconUser from '../../images/common/icon_user.png';
import IconUser2x from '../../images/common/icon_user@2x.png';
import IconFacebook from '../../images/register/icon_facebook.png';
import IconFacebook2x from '../../images/register/icon_facebook@2x.png';
import { UserType } from '../../types';

type SnsProps = {
  userType: UserType;
}

const Sns = (props: SnsProps) => {
  return (
    <section>
      <h2 className="curve_title">
        <img
          src={ IconUser }
          srcSet={ `${ IconUser } 1x, ${ IconUser2x } 2x` }
          alt="ソーシャルアカウントで登録"
        />
        ソーシャルアカウントで登録</h2>
      <p>友人に知られたり、無断で投稿することはございません。</p>
      <ul className="sns_login">
        <li>
          <a href={ `/oauth/facebook/${ props.userType }` }>
            <img
              src={ IconFacebook }
              srcSet={ `${ IconFacebook } 1x, ${ IconFacebook2x } 2x` }
              alt="Facebook"
            />
            <span>Facebook</span>
          </a>
        </li>
      </ul>
    </section>
  );
}

export default Sns;
